function createNameplate(statistic) {
  const { total_chars, translated_chars, untranslated_chars, approved_chars, unapproved_chars,
          total_words, translated_words, untranslated_words, approved_words, unapproved_words } = statistic;
  const nameplate = document.createElement('div');
  nameplate.style.display = 'none';

  const table = document.createElement('div');
  table.classList.add('table');

  const total = 'Total';
  const translated = 'Translated';
  const untranslated = 'Untranslated';
  const approved = 'Approved';
  const unapproved = 'Unapproved';
  createRow(table, total, total_chars, total_words)
  createRow(table, untranslated, untranslated_chars, untranslated_words)
  createRow(table, translated, translated_chars, translated_words)
  createRow(table, unapproved, unapproved_chars, unapproved_words)
  createRow(table, approved, approved_chars, approved_words)

  const footer = document.createElement('div');
  footer.classList.add('arrow-down');

  nameplate.appendChild(table)
  nameplate.appendChild(footer)

  return nameplate;
}

function createRow(table, key, chars, words) {
  if (chars == null || words == null)
    return

  const row = document.createElement('div');
  row.classList.add('row');

  row.appendChild(createCol(`${key}: `));
  row.appendChild(createCol(
    `${chars} ${'chars'} | ${words} ${'words'}`
  ));

  table.appendChild(row);
}

function createCol(text) {
  const col = document.createElement('div');
  col.classList.add('col');
  col.innerHTML += text;

  return col;
}

function closeOtherNameplates() {
  $('.nameplate').each((i, elem) => {
    elem.style.display = 'none';
  })
}

function onClickEvent(event) {
  const current = event.currentTarget;
  for (let child of current.children) {
    if(child.className.includes('nameplate')) {
      if (child.style.display === 'none') {
        closeOtherNameplates();
        child.style.display = 'flex';
      } else {
        child.style.display = 'none';
      }
    }
  }
}

export function renderNameplate(statistic) {
  const current = $('[data-behavior~=language_characters_result]')[0];

  const nameplate = createNameplate(statistic);

  nameplate.classList.add('nameplate');

  current.appendChild(nameplate);
}

export function addNameplate(current, statistic) {
  const nameplate = createNameplate(statistic);

  nameplate.classList.add('nameplate');

  current.appendChild(nameplate);
  current.addEventListener('click', onClickEvent);
}
